import { BaseDriver } from '@wix/wix-ui-test-utils/driver-factory';

export interface CardHeaderDriver extends BaseDriver {
  title(): string;
  subtitle(): string;
}
